import { ActionFunction } from 'react-router';
import { AuthError, AuthService } from '~/services/auth/AuthService';
import { queryClient } from '~/shared/api/query-client';
import { authUserQuery } from '~/shared/api/auth-user.queries';
import { isWavinOrOrbiaEmail } from '~/shared/utils/is-wavin-email';

export const hasValidWavinEmail = (
  submitEvent: React.FormEvent<HTMLFormElement>,
) => {
  const emailElement = submitEvent.currentTarget.elements.namedItem(
    'email',
  ) as HTMLInputElement;
  return isWavinOrOrbiaEmail(emailElement.value);
};

export type SignInActionErrorData = AuthError | null;

export const signInAction =
  (auth: AuthService): ActionFunction =>
  async ({ request }): Promise<SignInActionErrorData> => {
    const formData = await request.formData();
    const { email, password } = Object.fromEntries(formData);

    if (typeof email !== 'string') {
      return new AuthError(
        'expected-email-to-be-a-text',
        'Expected email to be a text',
      );
    }

    if (isWavinOrOrbiaEmail(email)) {
      const result = await auth.signInWithMicrosoft(email);
      await queryClient.invalidateQueries({
        queryKey: authUserQuery.queryKey,
      });
      return result;
    }

    if (typeof password !== 'string') {
      return new AuthError(
        'expected-password-to-be-a-text',
        'Expected password to be a text',
      );
    }
    const result = await auth.signIn(email, password);
    await queryClient.invalidateQueries({
      queryKey: authUserQuery.queryKey,
    });
    return result;
  };
